// 暗号化と復号のためのユーティリティ関数
import CryptoJS from 'crypto-js';

// 環境変数から暗号化キーを取得（Vercelの環境変数で設定）
export const getEncryptionKey = () => {
  // 本番環境では環境変数から取得
  if (process.env.REACT_APP_ENCRYPTION_KEY) {
    return process.env.REACT_APP_ENCRYPTION_KEY;
  }
  // 開発環境ではデフォルトキーを使用（本番環境では必ず環境変数を設定すること）
  return 'default-dev-key-please-change-in-production';
};

// 文字列を暗号化する関数（AES）
export const encrypt = (text) => {
  try {
    if (!text) return '';
    
    const key = getEncryptionKey();
    const encrypted = CryptoJS.AES.encrypt(text, key).toString();
    
    // URLセーフな文字列に変換
    return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch (error) {
    console.error('Encryption error:', error);
    return '';
  }
};

// 暗号化された文字列を復号する関数（AES）
export const decrypt = (encryptedText) => {
  try {
    if (!encryptedText) {
      console.log('decrypt: 暗号化テキストが空です');
      return '';
    }
    
    console.log('decrypt: 復号処理開始', encryptedText.substring(0, 10) + '...');
    
    // URL安全な文字を元に戻す
    let fixedEncrypted = encryptedText.replace(/-/g, '+').replace(/_/g, '/');
    console.log('decrypt: URL安全文字を置換', fixedEncrypted.substring(0, 10) + '...');
    
    // Base64の長さ調整
    while (fixedEncrypted.length % 4) {
      fixedEncrypted += '=';
    }
    console.log('decrypt: Base64長さ調整済み');
    
    const key = getEncryptionKey();
    console.log('decrypt: 暗号化キー取得済み');
    
    const bytes = CryptoJS.AES.decrypt(fixedEncrypted, key);
    console.log('decrypt: AES復号済み');
    
    const result = bytes.toString(CryptoJS.enc.Utf8);
    console.log('decrypt: 結果文字列変換済み', result ? '成功' : '失敗'); // 復号結果の値自体は表示しない
    
    return result;
  } catch (error) {
    console.error('Decryption error:', error);
    return '';
  }
};

// クッキーに暗号化して保存
export const setEncryptedCookie = (name, value, days = 30) => {
  try {
    const encryptedValue = encrypt(value);
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + days);
    document.cookie = `${name}=${encryptedValue};expires=${expiryDate.toUTCString()};path=/;SameSite=Strict`;
    return true;
  } catch (error) {
    console.error('Error setting cookie:', error);
    return false;
  }
};

// クッキーから取得して復号
export const getDecryptedCookie = (name) => {
  try {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return decrypt(cookieValue);
      }
    }
    return '';
  } catch (error) {
    console.error('Error getting cookie:', error);
    return '';
  }
};

// クッキーを削除
export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Strict`;
}; 